import {Box } from '@mui/material';
import ContactSupportForm from './ContactSupportForm';

import './ContactSupport.scss';

export enum SupportCategory {
    DEFAULT = '',
    BUG = 'Raise a Bug',
    FEATURE = 'Request New Feature',
    HELP = 'Request Help',
}

export enum SupportSubCategory {
    DEFAULT = '',
    HOME = 'Home Page',
    MONITORING = 'Campaign Monitoring',
    KPI = 'Step KPIs',
    TARGET = 'Campaign Targets',
    FORMS = 'Step Forms',
    BUILDER = 'Campaign Builder',
    CLONING = 'Campaing Cloning',
    OTHER = 'Other'
}

interface ContactSupportProps {
    handleClose: () => void
}

const ContactSupport = ({ handleClose }: ContactSupportProps) => {
    return (
        <Box className='contact-support-form'>
            <h1 className='contact-support-title'>Contact Support</h1>

            <ContactSupportForm handleClose={handleClose} />
        </Box>
    )
}

export default ContactSupport;
